//
// Copyright 2021 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/client/logging.proto (package dxos.client.services, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Error } from "../error_pb.js";
import { file_dxos_error } from "../error_pb.js";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/client/logging.proto.
 */
export const file_dxos_client_logging: GenFile = /*@__PURE__*/
  fileDesc("ChlkeG9zL2NsaWVudC9sb2dnaW5nLnByb3RvEhRkeG9zLmNsaWVudC5zZXJ2aWNlcyLBAgoQUXVlcnlMb2dzUmVxdWVzdBI+CgdmaWx0ZXJzGAEgAygLMi0uZHhvcy5jbGllbnQuc2VydmljZXMuUXVlcnlMb2dzUmVxdWVzdC5GaWx0ZXISTAoHb3B0aW9ucxgKIAEoDjI2LmR4b3MuY2xpZW50LnNlcnZpY2VzLlF1ZXJ5TG9nc1JlcXVlc3QuTWF0Y2hpbmdPcHRpb25zSACIAQEaWQoGRmlsdGVyEi0KBWxldmVsGAEgASgOMh4uZHhvcy5jbGllbnQuc2VydmljZXMuTG9nTGV2ZWwSFAoHcGF0dGVybhgCIAEoCUgAiAEBQgoKCF9wYXR0ZXJuIjgKD01hdGNoaW5nT3B0aW9ucxIICgROT05FEAASDQoJSU5DTFVTSVZFEAESDAoIRVhQTElDSVQQAkIKCghfb3B0aW9ucyKsAwoITG9nRW50cnkSLQoFbGV2ZWwYASABKA4yHi5keG9zLmNsaWVudC5zZXJ2aWNlcy5Mb2dMZXZlbBIPCgdtZXNzYWdlGAIgASgJEi0KB2NvbnRleHQYAyABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0SACIAQESNgoEbWV0YRgEIAEoCzIjLmR4b3MuY2xpZW50LnNlcnZpY2VzLkxvZ0VudHJ5Lk1ldGFIAYgBARIlCgVlcnJvchgFIAEoCzIRLmR4b3MuZXJyb3IuRXJyb3JIAogBARItCgl0aW1lc3RhbXAYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wGoMBCgRNZXRhEgwKBGZpbGUYASABKAkSDAoEbGluZRgCIAEoBRIrCgVzY29wZRgDIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3RIAIgBARIYCgtyZXNvdXJjZV9pZBgEIAEoBUgBiAEBQggKBl9zY29wZUIOCgxfcmVzb3VyY2VfaWRCCgoIX2NvbnRleHRCBwoFX21ldGFCCAoGX2Vycm9yKlYKCExvZ0xldmVsEggKBE5PTkUQABIJCgVUUkFDRRAFEgkKBURFQlVHEAoSCwoHVkVSQk9TRRALEggKBElORk8QDBIICgRXQVJOEA0SCQoFRVJST1IQDmIGcHJvdG8z", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_dxos_error]);

/**
 * @generated from message dxos.client.services.QueryLogsRequest
 */
export type QueryLogsRequest = Message<"dxos.client.services.QueryLogsRequest"> & {
  /**
   * @generated from field: repeated dxos.client.services.QueryLogsRequest.Filter filters = 1;
   */
  filters: QueryLogsRequest_Filter[];

  /**
   * @generated from field: optional dxos.client.services.QueryLogsRequest.MatchingOptions options = 10;
   */
  options?: QueryLogsRequest_MatchingOptions;
};

/**
 * Describes the message dxos.client.services.QueryLogsRequest.
 * Use `create(QueryLogsRequestSchema)` to create a new message.
 */
export const QueryLogsRequestSchema: GenMessage<QueryLogsRequest> = /*@__PURE__*/
  messageDesc(file_dxos_client_logging, 0);

/**
 * @generated from message dxos.client.services.QueryLogsRequest.Filter
 */
export type QueryLogsRequest_Filter = Message<"dxos.client.services.QueryLogsRequest.Filter"> & {
  /**
   * @generated from field: dxos.client.services.LogLevel level = 1;
   */
  level: LogLevel;

  /**
   * @generated from field: optional string pattern = 2;
   */
  pattern?: string;
};

/**
 * Describes the message dxos.client.services.QueryLogsRequest.Filter.
 * Use `create(QueryLogsRequest_FilterSchema)` to create a new message.
 */
export const QueryLogsRequest_FilterSchema: GenMessage<QueryLogsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_dxos_client_logging, 0, 0);

/**
 * @generated from enum dxos.client.services.QueryLogsRequest.MatchingOptions
 */
export enum QueryLogsRequest_MatchingOptions {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * / Filters match all log levels above. Default behaviour for the logger.
   *
   * @generated from enum value: INCLUSIVE = 1;
   */
  INCLUSIVE = 1,

  /**
   * / Explicitly specify all desired log levels.
   *
   * @generated from enum value: EXPLICIT = 2;
   */
  EXPLICIT = 2,
}

/**
 * Describes the enum dxos.client.services.QueryLogsRequest.MatchingOptions.
 */
export const QueryLogsRequest_MatchingOptionsSchema: GenEnum<QueryLogsRequest_MatchingOptions> = /*@__PURE__*/
  enumDesc(file_dxos_client_logging, 0, 0);

/**
 * @generated from message dxos.client.services.LogEntry
 */
export type LogEntry = Message<"dxos.client.services.LogEntry"> & {
  /**
   * @generated from field: dxos.client.services.LogLevel level = 1;
   */
  level: LogLevel;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: optional google.protobuf.Struct context = 3;
   */
  context?: JsonObject;

  /**
   * @generated from field: optional dxos.client.services.LogEntry.Meta meta = 4;
   */
  meta?: LogEntry_Meta;

  /**
   * @generated from field: optional dxos.error.Error error = 5;
   */
  error?: Error;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 6;
   */
  timestamp?: Timestamp;
};

/**
 * Describes the message dxos.client.services.LogEntry.
 * Use `create(LogEntrySchema)` to create a new message.
 */
export const LogEntrySchema: GenMessage<LogEntry> = /*@__PURE__*/
  messageDesc(file_dxos_client_logging, 1);

/**
 * @generated from message dxos.client.services.LogEntry.Meta
 */
export type LogEntry_Meta = Message<"dxos.client.services.LogEntry.Meta"> & {
  /**
   * @generated from field: string file = 1;
   */
  file: string;

  /**
   * @generated from field: int32 line = 2;
   */
  line: number;

  /**
   * @generated from field: optional google.protobuf.Struct scope = 3;
   */
  scope?: JsonObject;

  /**
   * @generated from field: optional int32 resource_id = 4;
   */
  resourceId?: number;
};

/**
 * Describes the message dxos.client.services.LogEntry.Meta.
 * Use `create(LogEntry_MetaSchema)` to create a new message.
 */
export const LogEntry_MetaSchema: GenMessage<LogEntry_Meta> = /*@__PURE__*/
  messageDesc(file_dxos_client_logging, 1, 0);

/**
 * NOTE: Keep aligned with LogLevel in @dxos/log.
 *
 * @generated from enum dxos.client.services.LogLevel
 */
export enum LogLevel {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: TRACE = 5;
   */
  TRACE = 5,

  /**
   * @generated from enum value: DEBUG = 10;
   */
  DEBUG = 10,

  /**
   * @generated from enum value: VERBOSE = 11;
   */
  VERBOSE = 11,

  /**
   * @generated from enum value: INFO = 12;
   */
  INFO = 12,

  /**
   * @generated from enum value: WARN = 13;
   */
  WARN = 13,

  /**
   * @generated from enum value: ERROR = 14;
   */
  ERROR = 14,
}

/**
 * Describes the enum dxos.client.services.LogLevel.
 */
export const LogLevelSchema: GenEnum<LogLevel> = /*@__PURE__*/
  enumDesc(file_dxos_client_logging, 0);

